












































































import { bus } from "@/bus";
import { Getter } from "vuex-class";
import { fixedHtmlData, fileUploadStages } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { BehaviorEnum } from "@/services/posts/types";
import BehaviorDropdown from "@/components/posts/BehaviorDropdown.vue";
import i18n from "@/i18n";
@Component({
    components: {
        BehaviorDropdown
    }
})
export default class ImageComponentForm extends Vue {
    @Prop() vsid!: string;
    @Prop() styles!: string;
    @Prop() fileuploadinprogress!: fileUploadStages;
    @Getter("authentication/getUserHasFolderAccess") getUserHasFolderAccess: any;
    @Getter("getAllowStockImages") allowStockImages!: boolean;

    isDraggedOver = false;
    showBehavior = false;
    ratio = 1;
    factor = 1;
    allowDrag = false;
    allowResize = false;
    isBehaviorDisabled = false;
    cropOnly = false;

    channelWidth = 0;
    channelHeight = 0;

    containerSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0
    };

    imageSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0,
        cropSizeWidth: 0,
        cropSizeHeight: 0
    };

    dragPosition = {
        x: 0,
        y: 0,
        initialX: 0,
        initialY: 0,
        initialCropPosition: 0,
        resizeX: 0,
        resizeY: 0,
        resizeWidth: 0,
        resizeHeight: 0
    }

    img = {
        width: 0,
        height: 0
    };

    imageDisplayStyles = "";

    behaviorTypes: any = Object.keys(BehaviorEnum)
        .map(key => ({ name: i18n.t(`posts.${key}`), id: key }));

    properties = {
        ...((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0]
    } as fixedHtmlData

    get src() {
        return this.properties.src || "https://placehold.jp/200x200.png"; // Placeholder todo
    }

    get cropStyle() {
        return `
            width: ${this.imageSize.cropSizeWidth}px;
            height: ${this.imageSize.cropSizeHeight}px;
            top: ${this.dragPosition.y}px;
            left: ${this.dragPosition.x}px;
        `;
    }

    get displayContainerStyles() {
        if (this.isBehaviorDisabled) return "";
        return `width: ${this.channelWidth}px; height: ${this.channelHeight}px;`;
    }

    @Watch("properties.behavior", { immediate: true }) localPropWatch() {
        this.calcLetterbox();
    }

    mounted() {
        const div = document.createElement("div");
        div.style.cssText = this.styles;
        if (div.style.width && div.style.height) {
            this.channelWidth = parseInt(div.style.width);
            this.channelHeight = parseInt(div.style.height);
        } else {
            this.isBehaviorDisabled = true;
            this.imageDisplayStyles = "";
        }

        bus.$on("changeImage", (id: string, src: string) => {
            if (id === this.properties.id) {
                this.properties.src = src;
                this.loadImage(id);
            }
        });

        bus.$on("getComponentData", () => {
            const props = ((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0] as fixedHtmlData;
            props.behavior = this.properties.behavior;
            props.src = this.src;
            props.position = {
                id: this.src,
                x: this.dragPosition.x === 0 ? 0 : (this.dragPosition.x / this.factor),
                y: this.dragPosition.y === 0 ? 0 : (this.dragPosition.y / this.factor),
                editorX: this.dragPosition.x,
                editorY: this.dragPosition.y,
                cropSizeWidth: this.imageSize.cropSizeWidth ? this.imageSize.cropSizeWidth : null,
                cropSizeHeight: this.imageSize.cropSizeHeight ? this.imageSize.cropSizeHeight : null,
                factor: this.factor ? this.factor : null,
                channelWidth: this.channelWidth,
                channelHeight: this.channelHeight,
                imgWidth: this.img.width,
                imgHeight: this.img.height
            };
            this.properties = { ...props };
        });

        this.loadImage(this.properties.id);

        // TODO: make sure 2 images work
        document.addEventListener("mousemove", this.resize);
        document.addEventListener("mousedown", this.resizeStart);
        document.addEventListener("mouseup", this.resizeEnd);

        document.addEventListener("mousemove", this.drag);
        document.addEventListener("mousedown", this.dragStart);
        document.addEventListener("mouseup", this.dragEnd);
    }

    destroyed() {
        bus.$off("changeImage");
        bus.$off("getComponentData");
        document.removeEventListener("mousemove", this.resize);
        document.removeEventListener("mousedown", this.resizeStart);
        document.removeEventListener("mouseup", this.resizeEnd);
        document.removeEventListener("mousemove", this.drag);
        document.removeEventListener("mousedown", this.dragStart);
        document.removeEventListener("mouseup", this.dragEnd);
    }

    setDisplayImageStyles() {
        this.imageDisplayStyles = "";

        if (this.properties.behavior === BehaviorEnum.adjust) {
            const ratio = Math.max(this.channelWidth / this.img.width, this.channelHeight / this.img.height);
            const ratio2 = Math.max((this.channelWidth * this.factor) / this.imageSize.cropSizeWidth, (this.channelHeight * this.factor) / this.imageSize.cropSizeHeight);

            this.imageDisplayStyles = `
                transform: scale(${ratio * ratio2});
                margin-left: ${-(this.dragPosition.x / this.factor) * ratio2}px;
                margin-top: ${-(this.dragPosition.y / this.factor) * ratio2}px;
            `;
        }

        if (this.properties.behavior === BehaviorEnum.crop) {
            if (this.ratio < 1) this.imageDisplayStyles = `transform: scale(${this.ratio}) translate(-50%, -50%)`;
        }

        if (this.properties.behavior === BehaviorEnum.letterBox) {
            if (this.img.width > this.channelWidth || this.img.height > this.channelHeight) {
                const ratio = Math.min(this.channelWidth / this.img.width, this.channelHeight / this.img.height);
                this.imageDisplayStyles = `
                    width: ${this.img.width * ratio}px;
                    height: ${this.img.height * ratio}px;
                `;
            }
        }
    }

    changeImage() {
        bus.$emit("openFileSelect", this.properties.id);
    }

    directUpload() {
        bus.$emit("openDirectUpload", this.properties.id);
    }

    stockImageDownload() {
        bus.$emit("stockImageDownload", this.properties.id);
    }

    dragEnter() {
        this.isDraggedOver = true;
    }

    dragLeave() {
        this.isDraggedOver = false;
    }

    dragOver(e: any) {
        e.preventDefault();
    }

    drop(e: any) {
        this.isDraggedOver = false;
        e.preventDefault();
        const file = e.dataTransfer.files[0]; // Since an image component only holds 1 image, there's no need to support multi-upload.
        if (file) bus.$emit("injectFile", file, this.properties.id);
    }

    calcAspectRatio(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number, imgWidth: number, imgHeight: number) {
        let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        if (ratio > 1) ratio = 1;

        const calc = { width: srcWidth * ratio, height: srcHeight * ratio, ratio };
        this.containerSize.width = calc.width;
        this.containerSize.height = calc.height;
        this.containerSize.origWidth = calc.width;
        this.containerSize.origHeight = calc.height;
        this.imageSize.width = imgWidth * calc.ratio;
        this.imageSize.height = imgHeight * calc.ratio;
        this.imageSize.origWidth = imgWidth * calc.ratio;
        this.imageSize.origHeight = imgHeight * calc.ratio;
    }

    loadImage(id: string) {
        const image = new Image();
        image.onload = () => {
            this.img.width = image.width;
            this.img.height = image.height;
            this.calcAspectRatio(this.channelWidth, this.channelHeight, 300, 300, image.width, image.height);
            this.calcLetterbox();
        };
        image.src = this.src;
    }

    calcLetterbox() {
        if (this.isBehaviorDisabled) return;
        this.ratio = Math.max(this.channelWidth / this.img.width, this.channelHeight / this.img.height);
        if (this.properties.behavior === BehaviorEnum.adjust) {
            this.containerSize.width = 300;
            this.containerSize.height = 300;

            // Calculate how much to zoom the image (ratio) and how much to zoom the total package (crop & image) afterwards (factor)
            const maxSize = Math.min(Math.max(this.channelWidth, this.channelHeight), 300);
            this.factor = Math.min(maxSize / (this.img.width * this.ratio), maxSize / (this.img.height * this.ratio));

            // Size the image and the crop according to the above calculations
            this.imageSize.width = this.img.width * this.factor;
            this.imageSize.height = this.img.height * this.factor;
            this.imageSize.cropSizeWidth = this.channelWidth * this.factor;
            this.imageSize.cropSizeHeight = this.channelHeight * this.factor;

            // We only restore the state of the crop square if the exact conditions are met:
            // The image must be the same, the position must exist, and the channel width and height must be unchanged
            if (this.properties.position && this.properties.position.id === this.src && this.properties.position.channelWidth === this.channelWidth && this.properties.position.channelHeight === this.channelHeight) {
                this.dragPosition.x = this.properties.position.editorX;
                this.dragPosition.y = this.properties.position.editorY;
                if (this.properties.position.cropSizeWidth && this.properties.position.cropSizeHeight) {
                    this.imageSize.cropSizeWidth = this.properties.position.cropSizeWidth;
                    this.imageSize.cropSizeHeight = this.properties.position.cropSizeHeight;
                }
            } else {
                // Otherwise just center the crop square
                this.dragPosition.x = Math.ceil(((this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth) / 2) || 0;
                this.dragPosition.y = Math.ceil(((this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight) / 2) || 0;
            }
        }

        this.setDisplayImageStyles();
    }

    dragStart(e: any) {
        if (!e.target.classList.contains("crop-square")) return;
        if (!e.target.classList.contains(`vs-id-${this.vsid}`)) return;

        if ((this.imageSize.width * this.ratio) <= this.imageSize.cropSizeWidth && (this.imageSize.height * this.ratio) <= this.imageSize.cropSizeHeight) return;
        this.allowDrag = true;
        this.dragPosition.initialX = e.clientX;
        this.dragPosition.initialY = e.clientY;
    }

    dragEnd() {
        if (!this.allowDrag) return;
        this.allowDrag = false;
    }

    drag(e: any) {
        if (this.allowResize) {
            this.allowDrag = false;
            return;
        }
        if (!this.allowDrag) return;
        e.preventDefault();
        const cropSquare = (this.$refs.cropsquare as any);
        const pos1 = this.dragPosition.initialX - e.clientX;
        const pos2 = this.dragPosition.initialY - e.clientY;
        this.dragPosition.initialX = e.clientX;
        this.dragPosition.initialY = e.clientY;
        let newPos1 = cropSquare.offsetLeft - pos1;
        let newPos2 = cropSquare.offsetTop - pos2;

        // Prevent from dragging the crop box out of image bounds
        if (newPos2 < 0) newPos2 = 0;
        if (newPos1 <= 0) newPos1 = 0;
        if (newPos1 >= (this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth) newPos1 = Math.round((this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth);
        if (newPos2 >= (this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight) newPos2 = Math.round((this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight);

        this.dragPosition.x = newPos1;
        this.dragPosition.y = newPos2;
        this.setDisplayImageStyles();
    }

    resizeStart(e: any) {
        if (!e.target.classList.contains("crop-resize") && !e.target.parentNode.classList.contains("crop-resize")) return;
        if (!e.target.classList.contains(`vs-id-${this.vsid}`) && !e.target.parentNode.classList.contains(`vs-id-${this.vsid}`)) return;
        this.allowResize = true;
        this.dragPosition.resizeX = e.clientX;
        this.dragPosition.resizeY = e.clientY;
        this.dragPosition.resizeWidth = this.imageSize.cropSizeWidth;
        this.dragPosition.resizeHeight = this.imageSize.cropSizeHeight;
    }

    resizeEnd() {
        if (!this.allowResize) return;
        this.allowResize = false;
    }

    resize(e: any) {
        if (!this.allowResize) return;
        e.preventDefault();
        const minWidth = 50;
        const cropRatio = (this.dragPosition.resizeHeight / this.dragPosition.resizeWidth);
        const width = this.dragPosition.resizeX - e.clientX;
        let newWidth = this.dragPosition.resizeWidth - width;
        let newHeight = (this.dragPosition.resizeWidth - width) * cropRatio;
        // Don't allow resize to be smaller than minWidth
        if (this.dragPosition.resizeWidth - width <= minWidth) {
            newWidth = minWidth;
            newHeight = minWidth * cropRatio;
        }

        // Don't allow resize to go out of the image bounds
        if ((Math.ceil((newWidth + this.dragPosition.x)) > Math.ceil((this.imageSize.width * this.ratio)))) {
            const maxWidth = Math.ceil(this.imageSize.width * this.ratio) - this.dragPosition.x;
            newWidth = maxWidth;
            newHeight = maxWidth * cropRatio;
        }

        if ((Math.ceil((newHeight + this.dragPosition.y)) > Math.ceil((this.imageSize.height * this.ratio)))) {
            const maxHeight2 = Math.ceil(this.imageSize.height * this.ratio) - this.dragPosition.y;
            newWidth = maxHeight2 * (this.dragPosition.resizeWidth / this.dragPosition.resizeHeight);
            newHeight = maxHeight2;
        }

        this.imageSize.cropSizeWidth = newWidth;
        this.imageSize.cropSizeHeight = newHeight;
        this.setDisplayImageStyles();
    }
}
